"use strict";

exports.__esModule = true;
exports.renderTextWithLinks = exports.parseChecklistItemsFromContent = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var parseChecklistItemsFromContent = function parseChecklistItemsFromContent(content, setIsContentValid) {
  try {
    var parsedContent = JSON.parse(content);
    var items = parsedContent && parsedContent.items || [];
    setIsContentValid(true);
    return items;
  } catch (error) {
    setIsContentValid(false);
    return [];
  }
};

exports.parseChecklistItemsFromContent = parseChecklistItemsFromContent;

var renderTextWithLinks = function renderTextWithLinks(text) {
  if (!text) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  var urlRegex = /(https?:\/\/\S+)/g;
  var textWithAnchorTags = text.split(urlRegex).map(function (part, index) {
    if (index % 2 === 0) {
      return part;
    } else {
      var displayText = part.length > 50 ? part.substring(0, 50) + '...' : part;
      return /*#__PURE__*/_react.default.createElement("a", {
        key: index,
        href: part,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          textDecoration: 'underline'
        }
      }, displayText);
    }
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, textWithAnchorTags);
};

exports.renderTextWithLinks = renderTextWithLinks;